import React from 'react';
import { Link } from 'react-router-dom';

function List({ children }) {
  return <div className="flex flex-col gap-y-4 mt-4">{children}</div>;
}

function ListItem({ href, children }) {
  return (
    <Link
      to={href}
      className="-m-2 p-2 rounded-md hover:bg-gray-50 w-full flex text-sm h-16 gap-x-2"
    >
      {children}
    </Link>
  );
}

function Left({ children }) {
  return <div className="space-y-1 truncate">{children}</div>;
}

function Right({ children }) {
  return <div className="ml-auto text-right space-y-1">{children}</div>;
}

function PrimaryText({ children }) {
  return <p className="font-medium">{children}</p>;
}

function SecondaryText({ children }) {
  return <p className="text-gray-500 truncate">{children}</p>;
}

function EmptyState({ children }) {
  return <div className="text-gray-500">{children}</div>;
}

const StatisticsList = {
  List: List,
  Item: ListItem,
  Left: Left,
  Right: Right,
  PrimaryText: PrimaryText,
  SecondaryText: SecondaryText,
  EmptyState: EmptyState,
};

export default StatisticsList;
